var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO2Meter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 81,
    viewBox: "0 0 153 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.647 80.5812C106.027 80.5633 104.472 79.9426 103.286 78.8404C102.1 77.7381 101.368 76.2336 101.234 74.6208C100.693 68.4411 97.854 62.6881 93.2763 58.497C88.6987 54.3059 82.715 51.9809 76.5058 51.9809C70.2966 51.9809 64.3129 54.3059 59.7353 58.497C55.1576 62.6881 52.3185 68.4411 51.7781 74.6208C51.6433 76.2336 50.9114 77.7381 49.7253 78.8404C48.5393 79.9426 46.9844 80.5633 45.3646 80.5812H9.10509C7.9169 80.5811 6.74129 80.3382 5.65051 79.8675C4.55973 79.3969 3.57681 78.7083 2.76221 77.8441C1.97272 77.0112 1.36541 76.0232 0.978888 74.9431C0.592364 73.8629 0.435094 72.7142 0.517102 71.57C1.78825 52.3021 10.3461 34.2381 24.4555 21.0406C38.5648 7.84317 57.1697 0.5 76.4979 0.5C95.8262 0.5 114.431 7.84317 128.54 21.0406C142.65 34.2381 151.208 52.3021 152.479 71.57C152.561 72.7142 152.404 73.8629 152.017 74.9431C151.631 76.0232 151.023 77.0112 150.234 77.8441C149.419 78.7083 148.436 79.3969 147.345 79.8675C146.255 80.3382 145.079 80.5811 143.891 80.5812H107.647Z",
    fill: "url(#paint0_linear_14_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.647 80.0949C106.153 80.079 104.718 79.508 103.623 78.4932C102.527 77.4783 101.849 76.0923 101.72 74.6051C101.196 68.2821 98.3118 62.3871 93.6396 58.09C88.9673 53.7928 82.8487 51.4075 76.498 51.4075C70.1474 51.4075 64.0288 53.7928 59.3566 58.09C54.6843 62.3871 51.8 68.2821 51.2758 74.6051C51.1471 76.0923 50.4689 77.4783 49.3733 78.4932C48.2776 79.508 46.843 80.079 45.349 80.0949H9.10513C7.9835 80.095 6.87365 79.8662 5.84369 79.4225C4.81373 78.9789 3.88537 78.3296 3.11552 77.5147C2.37343 76.7282 1.80211 75.7969 1.43737 74.7793C1.07263 73.7617 0.922337 72.6798 0.995996 71.6014C2.29143 52.4778 10.8092 34.5596 24.8261 21.4718C38.8429 8.38399 57.3124 1.10367 76.498 1.10367C95.6837 1.10367 114.153 8.38399 128.17 21.4718C142.187 34.5596 150.705 52.4778 152 71.6014C152.073 72.6803 151.921 73.7626 151.555 74.7802C151.189 75.7978 150.616 76.7288 149.873 77.5147C149.105 78.3301 148.178 78.9798 147.149 79.4236C146.12 79.8673 145.011 80.0958 143.891 80.0949H107.647Z",
    fill: "url(#paint1_linear_14_2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 145,
    height: 73
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.212 72.3249C146.975 54.0621 138.841 36.9503 125.455 24.4515C112.069 11.9526 94.4306 5 76.1085 5C57.7864 5 40.1483 11.9526 26.7624 24.4515C13.3766 36.9503 5.24247 54.0621 4.00562 72.3249C3.97438 72.9585 4.07363 73.5918 4.29722 74.1853C4.52082 74.779 4.86398 75.3205 5.30551 75.7763C5.74703 76.2321 6.27749 76.5926 6.86407 76.8353C7.45064 77.0779 8.08086 77.1978 8.71567 77.1873H44.9594C45.5983 77.1798 46.2114 76.9345 46.6788 76.4995C47.1462 76.0644 47.4345 75.4707 47.4872 74.8346C48.0935 67.6678 51.3715 60.99 56.6721 56.1231C61.9727 51.2563 68.9094 48.5554 76.1085 48.5554C83.3077 48.5554 90.2444 51.2563 95.545 56.1231C100.846 60.99 104.124 67.6678 104.73 74.8346C104.783 75.4707 105.071 76.0644 105.539 76.4995C106.006 76.9345 106.619 77.1798 107.258 77.1873H143.502C144.137 77.1978 144.767 77.0779 145.353 76.8353C145.94 76.5926 146.47 76.2321 146.912 75.7763C147.354 75.3205 147.697 74.779 147.92 74.1853C148.144 73.5918 148.243 72.9585 148.212 72.3249Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M148.612 77.054C148.612 91.3801 144.36 105.384 136.393 117.296C128.426 129.208 117.103 138.492 103.855 143.974C90.6061 149.457 76.0281 150.891 61.9639 148.096C47.8996 145.301 34.9808 138.403 24.841 128.273C14.7012 118.142 7.79594 105.236 4.99838 91.1852C2.20083 77.1344 3.63667 62.5703 9.12427 49.3347C14.6119 36.0991 23.9048 24.7864 35.8279 16.8272C47.751 8.86812 61.7687 4.61993 76.1085 4.61993C95.337 4.62201 113.778 12.2541 127.374 25.8376C140.971 39.4212 148.61 57.8439 148.612 77.054Z",
    fill: "url(#paint2_radial_14_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_2",
    x1: 76.498,
    y1: 80.5812,
    x2: 76.498,
    y2: 0.610319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_2",
    x1: 76.4981,
    y1: 80.0949,
    x2: 76.4981,
    y2: 1.09658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.1086 77.054) scale(72.5033 72.4341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EBECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DADDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#C4C9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A8B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8993BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6572A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2Meter);
export default __webpack_public_path__ + "static/media/O2_meter.d194a1de98081bb0ce25d5c042b435b0.svg";
export { ForwardRef as ReactComponent };